import constants from "./constants";
import createAction from "sagas/createAction";
import { createPromiseAction } from "@adobe/redux-saga-promise";

const actions = {
  getLeadTarget: createPromiseAction(constants.GET_LEAD_TARGET),
  saveCRMSettingLeadForm: createPromiseAction(constants.SAVE_CRM_SETTING_LEAD_FORM),
  setGateItem: (gateItem) => createAction(constants.SET_GATE_ITEM, { gateItem }),
  saveCRMGGLeadsSetting: createPromiseAction(constants.SAVE_CRM_GG_LEADS_SETTING),
  setCRMLoading: (loading) => createAction(constants.SET_CRM_LOADING, { loading }),
  setValidateGate: (validateGate) => createAction(constants.SET_VALIDATE_GATE, { validateGate }),
};

export default actions;
